/**
 * IFU Archive Page Scripts
 */

document.addEventListener('DOMContentLoaded', function() {
    // Filter Toggle
    const filterButtons = document.querySelectorAll('.ifus-filter-title');
    
    // open / close menu widget
    filterButtons.forEach(button => {
        button.addEventListener('click', function() {
            const filterGroup = this.closest('.ifus-filter-group');
            filterGroup.classList.toggle('open');
        });
    });

    // Search Functionality
    const searchInput = document.getElementById('ifus-search-input');
    const searchBtn = document.querySelector('.ifus-search-btn');
    const allFilterItems = document.querySelectorAll('.ifus-filter-item');
    const categoryFilterItems = document.querySelectorAll('#categoria .ifus-filter-item');
    const brandFilterItems = document.querySelectorAll('#marca .ifus-filter-item');
    const productCards = document.querySelectorAll('.ifus-product-card');
    const searchTerm = document.getElementById('ifus-search-term');
    const searchTermValue = document.getElementById('ifus-search-term-value');

    const FILTER_PARTAM_CATEGORIES = 'categorias';
    const FILTER_PARTAM_BRANDS = 'marcas';

    /**
     * Get filters from URL parameters
     */
    const getFiltersFromURL = () => {
        const params = new URLSearchParams(window.location.search);
        return {
            categories: params.get(FILTER_PARTAM_CATEGORIES) ? params.get(FILTER_PARTAM_CATEGORIES).split(',') : [],
            brands: params.get(FILTER_PARTAM_BRANDS) ? params.get(FILTER_PARTAM_BRANDS).split(',') : []
        };
    };

    /**
     * Update URL with current filters
     */
    const updateURLFilters = () => {
        const activeCategoryFilters = Array.from(categoryFilterItems)
            .filter(item => item.classList.contains('is-active'))
            .map(item => item.getAttribute('data-filter'));

        const activeBrandFilters = Array.from(brandFilterItems)
            .filter(item => item.classList.contains('is-active'))
            .map(item => item.getAttribute('data-filter'));

        const params = new URLSearchParams(window.location.search);

        if (activeCategoryFilters.length > 0) {
            params.set(FILTER_PARTAM_CATEGORIES, activeCategoryFilters.join(','));
        } else {
            params.delete(FILTER_PARTAM_CATEGORIES);
        }

        if (activeBrandFilters.length > 0) {
            params.set(FILTER_PARTAM_BRANDS, activeBrandFilters.join(','));
        } else {
            params.delete(FILTER_PARTAM_BRANDS);
        }

        const newURL = params.toString() ? `${window.location.pathname}?${params.toString()}` : window.location.pathname;
        window.history.replaceState({}, '', newURL);
    };

    /**
     * Apply filters from URL on page load
     */
    const applyFiltersFromURL = () => {
        const urlFilters = getFiltersFromURL();

        // Apply category filters
        urlFilters.categories.forEach(category => {
            const filterItem = document.querySelector(`#categoria .ifus-filter-item[data-filter="${category}"]`);
            if (filterItem) {
                filterItem.classList.add('is-active');
            }
        });

        // Apply brand filters
        urlFilters.brands.forEach(brand => {
            const filterItem = document.querySelector(`#marca .ifus-filter-item[data-filter="${brand}"]`);
            if (filterItem) {
                filterItem.classList.add('is-active');
            }
        });

        // Perform search to apply filters
        if (urlFilters.categories.length > 0 || urlFilters.brands.length > 0) {
            performSearch();
        }
    };

    const performSearch = () => {
        const query = searchInput.value.trim().toLowerCase();

        if (query !== '' && searchTerm && searchTermValue) {
            searchTerm.style.display = 'block';
            searchTermValue.textContent = query;
        } else if (searchTerm) {
            searchTerm.style.display = 'none';
        }

        const activeCategoryFilters = Array.from(categoryFilterItems)
            .filter(item => item.classList.contains('is-active'))
            .map(item => item.getAttribute('data-filter'));

        const activeBrandFilters = Array.from(brandFilterItems)
            .filter(item => item.classList.contains('is-active'))
            .map(item => item.getAttribute('data-filter'));

        productCards.forEach(card => {
            const title = card.querySelector('.ifus-product-title').textContent.toLowerCase();

            const hasSearch = query !== '';
            const hasFilters = activeCategoryFilters.length > 0 || activeBrandFilters.length > 0;

            const matchesSearch = !hasSearch || title.includes(query);
            const matchesFilters = !hasFilters || (() => {
                const cardCategories = card
                    .getAttribute('data-categories')
                    .split(';')
                    .filter(Boolean);

                const cardBrands = card
                    .getAttribute('data-brands')
                    .split(';')
                    .filter(Boolean);

                if (activeCategoryFilters.length > 0 && !cardCategories.some(filter => activeCategoryFilters.includes(filter))) {
                    return false;
                }

                if (activeBrandFilters.length > 0 && !cardBrands.some(filter => activeBrandFilters.includes(filter))) {
                    return false;
                }

                return true;
            })();

            const shouldShow = matchesSearch && matchesFilters;

            card.style.display = shouldShow ? 'flex' : 'none';
        });
    };

    if (searchBtn) {
        searchBtn.addEventListener('click', function(e) {
            e.preventDefault();
            performSearch();
        });
    }

    if (searchInput) {
        searchInput.addEventListener('keyup', function() {
            performSearch();
        });
    }

    allFilterItems.forEach(item => {
        item.addEventListener('click', function(e) {
            e.preventDefault();

            // if parent has id marca disable other selected items in the same group
            const parentId = this.closest('.ifus-filter-list').id;
            
            if (parentId === 'marca') {
                const siblingItems = this.closest('.ifus-filter-list').querySelectorAll('.ifus-filter-item');
                siblingItems.forEach(sibling => {
                    if (sibling !== this) {
                        sibling.classList.remove('is-active');
                    }
                });
            }

            e.target.classList.toggle('is-active');
            performSearch();
            updateURLFilters();
        });
    });

    // Apply filters from URL on page load
    applyFiltersFromURL();

    // open filters on desktop by default
    const isDesktop = window.matchMedia("(min-width: 1024px)").matches;
    if (isDesktop) {
        document.querySelectorAll('.ifus-filter-group').forEach(group => {
            group.classList.add('open');
        });
    }
});
